import React from 'react';
import { ColorRing } from 'react-loader-spinner';

interface Props {
  title?: string;
  color?: string;
  innerText?: string;
  size?: string;
  onClick?: (...args: any[]) => void;
  icon?: string | React.ReactNode;
  fontSize?: number;
  rounded?: number;
  margin?: number;
  padding?: number;
  isGhost?: boolean;
  classNames?: string;
  href?: string;
  isItalic?: boolean;
  disabled?: boolean;
  isCustomIcon?: boolean;
  isLoading?: boolean;
}

export const MLButton: React.FC<Props> = ({
  onClick,
  icon,
  fontSize,
  rounded,
  innerText,
  isCustomIcon,
  title = '',
  color = 'danger',
  size = 'md',
  margin = 0,
  padding = 0,
  disabled = false,
  isGhost = false,
  isItalic = false,
  classNames = '',
  isLoading = false,
}) => {
  const buttonClassName = `
    btn w-${size} fs-${fontSize} m-${margin} p-${padding}
    ${rounded ? `rounded-${rounded}` : ''}
    btn-${isGhost ? 'ghost-' + color : color}
    ${isGhost ? 'waves-effect waves-light' : ''}
    ${classNames}
  `.trim();

  return (
    <button
      type="button"
      className={`${buttonClassName}`}
      onClick={onClick}
      disabled={disabled || isLoading}
      title={title}
    >
      <div className="d-flex align-items-center justify-content-center gap-2">
        {isCustomIcon && icon ? icon : icon && <i className={`${icon}`} />}
        {isItalic && innerText ? <i>{innerText}</i> : innerText}
        {isLoading && (
          <ColorRing
            visible
            height="24"
            width="24"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
          />
        )}
      </div>
    </button>
  );
};
